var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgClient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 360,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#img-client_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.542 314.801l11.736-54.647c12.055-56.133 59.329-95.981 113.864-95.981 54.536 0 101.81 39.848 113.865 95.981L314.667 361H88.5c-22.99 0-40.04-22.524-34.958-46.199z",
    fill: "#0026AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.379 237.436h31.092c4.847 0 8.921-3.634 9.471-8.438l7.2-62.362c.651-5.659-3.768-10.626-9.471-10.626h-31.092c-4.847 0-8.921 3.634-9.471 8.438l-7.2 62.362c-.662 5.659 3.768 10.626 9.471 10.626z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.243 238.371l18.925-7.35c2.91-1.128 4.82-4.58 3.821-7.538a5.919 5.919 0 00-7.74-3.62l3.543-1.375c2.91-1.128 4.82-4.58 3.821-7.538a5.92 5.92 0 00-7.741-3.621l2.98-1.157c2.91-1.128 4.82-4.58 3.82-7.538a5.92 5.92 0 00-7.74-3.621l-3.335 1.296a5.908 5.908 0 003.266-7.894c-1.257-2.859-4.999-4.115-7.908-2.978l-11.195 4.343-7.888 3.067-11.601 4.511a12.476 12.476 0 00-7.7 9.051l-6.968 32.645c-.01.029.01.049.029.059l20.449 36.532c.03.01.07 0 .079-.029l19.054-37.215c0-.01.01-.02.029-.03z",
    fill: "#B1C7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.249 219.863l-19.212 7.468M223.863 207.339l-23.112 8.972M219.587 196.329l-23.112 8.972",
    stroke: "#000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.164 349.523c-11.917-14.78-9.601-36.424 5.196-48.344l95.977-80.328 43.174 53.527-95.976 80.328c-14.798 11.92-36.454 9.596-48.371-5.183z",
    fill: "#012CC4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.157,
    cy: 135.819,
    rx: 20.187,
    ry: 20.195,
    fill: "#377AFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 237.407,
    cy: 132.655,
    rx: 16.769,
    ry: 16.776,
    fill: "#377AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.357 156.142c-30.331 0-54.919-24.598-54.919-54.942 0-30.343 24.588-54.941 54.919-54.941 30.331 0 54.92 24.598 54.92 54.941 0 30.344-24.589 54.942-54.92 54.942z",
    fill: "#B1C7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.622 109.514a1.747 1.747 0 11-.002-3.494 1.747 1.747 0 01.002 3.494zM219.125 110.859a1.748 1.748 0 110-3.496 1.748 1.748 0 010 3.496z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.789 121.672a5.456 5.456 0 004.064-.906 5.41 5.41 0 002.233-3.513 5.447 5.447 0 00-.906-4.062 4.096 4.096 0 00-.439-.539c-1.684-1.848-2.627-4.254-2.197-6.715.394-2.241.76-4.364.76-4.364M204.178 129.722c-5.163 3.641-10.563 3.751-16.275-.576",
    stroke: "#000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.473 72.99s-25.044 31.606-75.103 29.283c-.009-.439-.037-.878-.037-1.327 0-30.207 24.594-54.687 54.919-54.687 30.336 0 54.92 24.49 54.92 54.687 0 .174-.01.339-.01.513-14.947-5.197-26.237-12.853-34.689-28.47z",
    fill: "#377AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.542 121.809c-7.016 0-12.704-5.685-12.704-12.698 0-7.012 5.688-12.697 12.704-12.697 7.017 0 12.705 5.685 12.705 12.697 0 7.013-5.688 12.698-12.705 12.698z",
    fill: "#B1C7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.803 101.43l-2.342-3.874 1.903-4.107-2.342-3.874 1.91-4.112-2.34-3.886M166.736 99.477l-2.341-3.874 1.907-4.1-2.347-3.88 1.91-4.112-2.339-3.887",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.6 106h-43.2c-2.982 0-5.4 2.396-5.4 5.352v28.85c0 2.955 2.418 5.352 5.4 5.352l17.4-.001v8.169c0 .154.125.278.28.278a.283.283 0 00.198-.081l8.44-8.366 16.882.001c2.982 0 5.4-2.397 5.4-5.352v-28.85c0-2.956-2.418-5.352-5.4-5.352z",
    fill: "#B1C7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299 117.051c0-.58.471-1.051 1.051-1.051h30.898a1.052 1.052 0 010 2.102h-30.898a1.05 1.05 0 01-1.051-1.051zm0 8c0-.58.471-1.051 1.051-1.051h30.898a1.052 1.052 0 010 2.102h-30.898a1.05 1.05 0 01-1.051-1.051zm1.051 6.949a1.052 1.052 0 000 2.102h17.698a1.05 1.05 0 100-2.102h-17.698z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "img-client_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(-1 0 0 1 360 0)",
    d: "M0 0h360v360H0z"
  })))));
}
export default SvgImgClient;